import { FC } from 'react';
import { RingLoader } from 'react-spinners';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import theme from '../../../styles/themes/default';
import { Container } from './styles';

interface IProps {
  title: string;
  data: any;
  barColorList: string[];
  barColorListHover: string[];
  isLoading: boolean;
  isFetching: boolean;
  error: any;
}

const DobleBarChart: FC<IProps> = ({
  title,
  data,
  barColorList,
  barColorListHover,
  isLoading,
  isFetching,
  error,
}) => {
  return (
    <Container>
      {(isLoading || isFetching) && <h3>Carregando...</h3>}
      {error! && <h3>Falha ao carregar dados.</h3>}

      {(!isLoading || !isFetching) && data && data?.length > 0 && (
        <h3>{title}</h3>
      )}

      {!isLoading && !isFetching && (!data || data?.length === 0) && (
        <h3>'Não encontramos dados para sua pesquisa.'</h3>
      )}
      <ResponsiveContainer
        width="100%"
        height="100%"
        key={Math.floor(Math.random() * 45)}
      >
        {!isLoading && !isFetching ? (
          <BarChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid stroke={theme.colors.gray[200]} />
            <XAxis
              dataKey="month"
              style={{
                fontSize: '16px',
                fontWeight: 800,
                color: theme.colors.gray[600],
              }}
            />
            <YAxis style={{ stroke: 'none' }} />
            <Tooltip
              formatter={(value, name, props) => [
                ` R$ ${value.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`,
                name,
              ]}
            />
            <Legend />

            {data?.length > 0 &&
              Object.keys(data?.[0] ?? {}).map((key: string, i: number) => {
                if (key === 'month') return;
                return (
                  <Bar
                    width={24}
                    dataKey={key}
                    fill={barColorList[i]}
                    activeBar={
                      <Rectangle fill={barColorListHover[i]} stroke={barColorList[i]} />
                    }
                  />
                );
              })}
          </BarChart>
        ) : (
          <aside>
            <RingLoader size={136} />
          </aside>
        )}
      </ResponsiveContainer>
    </Container>
  );
};

export default DobleBarChart;
